<template>
  <div class="ticket-card" v-if="ticket">
    <div class="card" v-loading="!ticket._id">
      <div class="card-header">
        <h4 class="card-title"><i class="ti-ticket"></i>Dados do Ticket</h4>
      </div>
      <div class="card-content">
        <div class="row">
          <div class="col-xs-12">
            <dl class="dl-horizontal">
              <dt>Evento</dt>
              <dd>{{ event ? `${event.reference} - ${event.place}` : '-' }}</dd>
              <dt>Estoque</dt>
              <dd>
                <span class="label" :class="hasStock ? 'label-success' : 'label-danger'">
                {{ hasStock ? stock.description : 'Sem estoque' }}
                </span>
              </dd>
              <dt>Ticket sorteado?</dt>
              <dd>
                <span class="label" :class="winner ? 'label-success' : 'label-danger'">
                  {{ winner ? 'Sim' : 'Não' }}
                </span>
              </dd>
              <dt>Esteve presente?</dt>
              <dd>
                <span class="label" :class="checkin ? 'label-success' : 'label-danger'">
                  {{ checkin ? 'Sim' : 'Não' }}
                </span>
              </dd>
              <dt>Código de barra</dt>
              <dd @click="loadTicket"><a>{{ ticket.barcode }}</a></dd>
              <dt>Documentado?</dt>
              <dd>
                <span class="label" :class="documentedAt ? 'label-success' : 'label-danger'">
                {{ documentedAt ? documentedAt : 'Não' }}
                </span>
              </dd>
              <dt>Criado em</dt>
              <dd>{{ ticket.createdAt | moment('LLL') }}</dd>
              <dt>Ultima Atualização</dt>
              <dd>{{ updatedAt }}</dd>
              <dt>Criado por:</dt>
              <dd><strong>{{ users[ticket.userId] }}</strong></dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'ticket-card',

    props: {
      ticket: {
        required: true
      },
      stock: {
        required: true
      },
      event: {
        required: true
      }
    },

    computed: {
      ...mapGetters('users', {users: 'usersIdName'}),
      documentedAt: function () {
        return this.ticket.documentedAt ? this.$moment(this.ticket.documentedAt)
          .format('LLL') : false
      },
      updatedAt: function () {
        return this.ticket.updatedAt ? this.$moment(this.ticket.updatedAt)
          .format('LLL') : '-'
      },
      checkin: function () {
        return this.ticket.checkIn
      },
      winner: function () {
        return this.ticket.winner
      },
      hasStock: function () {
        return this.ticket.stockId && this.stock && this.stock.description !== ''
      }
    },

    methods: {
      loadTicket () {
        this.$emit('loadTicket', this.ticket)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Tickets/TicketCard.vue